<template>
  <div>
    <title-edit header="Online exhibition" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" >
        <v-app class="switch-app">
          <v-switch label="Publish" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Exhibition name TH*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_th" @update="updateTitleTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Exhibition name EN*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_en" @update="updateTitleEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description TH*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.detail_th" @update="updateDetailTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description EN*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.detail_en" @update="updateDetailTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slug Url</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.slug_url" @update="updateSlugUrl"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Attached website</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.attached_website" @update="updateAttachedWebsite"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Template*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <select-option :items="optionTemplate" :model="form.template_id" @update="updateTemplate"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Publish date</label>
      </v-col>
      <v-col cols="12" sm="8" >
       <date-picker :model.sync="form.publish_date" @update="updatePublishDate"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Background color</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <a @click="showModalSelectColor">
          <v-icon :color="form.background_color" style="font-size: 50px">
            fas fa-square
            <span>click select color</span>
          </v-icon>
        </a>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Cover image name</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.cover_image_name" @update="updateCoverImageName"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Cover image cover</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-image-upload id="image1" width="200px" height="150px" :model="form.cover_image_path"
                            @update="updateCoverImage"/>
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteData"/>
      <preview-button />
      <save-button @click.native="saveData"/>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modal"
      persistent
      width="290px">
      <div style="background-color: #1d2024">
        <select-color @update="updateBackgroundColor"/>
      </div>
    </v-dialog>
  </div>
</template>

<script>
    import TitleEdit from "../../../components/TitleHeader/TitleEdit";
    import LineHr from "../../../components/Icon/line-hr";
    import SelectOption from "../../../components/Input/selectOption";
    import InputTextField from "../../../components/Input/InputTextField";
    import DeleteButton from "../../../components/Button/DeleteButton";
    import PreviewButton from "../../../components/Button/PreviewButton";
    import SaveButton from "../../../components/Button/SaveButton";
    import DatePicker from "../../../components/Input/DatePicker";
    import SelectColor from "../../../components/Input/SelectColor";
    import InputImageUpload from "../../../components/Input/InputImageUpload";
    import {mapState} from "vuex";
    import InputEditor from "../../../components/Input/InputEditor";
    export default {
        name: "OnlineExhibitionEdit",
      components: {
        InputEditor,
        InputImageUpload,
        SelectColor,
        DatePicker,
        SaveButton,
        PreviewButton, DeleteButton,
        InputTextField, SelectOption, LineHr, TitleEdit},
      computed: {
        ...mapState({
          form: state => {
            return state.OnlineExhibition.form;
          }
        })
      },
      data(){
        return{
          modal : false,
          optionBranch : [],
          optionTemplate:[
            {value : '' , text : 'Select Template'},
            {value : 1 , text : '1'},
            {value : 2 , text : '2'},
          ]
        }
      },
      created() {
          this.getBranchData();
      },
      methods:{
        getBranchData() {
          this.$store.dispatch("Branch/getBranchAll").then(res => {
            this.optionBranch = [
              { text: "Select", value: "" },
              ...res.map(type => ({
                value: type.branch_id,
                text: type.branch_name_th + " (" + type.branch_name_en + ")"
              }))
            ];
          });
        },
        showModalSelectColor(){
          this.modal = true;
        },
        saveData(){
          this.$store.dispatch("OnlineExhibition/saveOnlineExhibition",{
            id : this.form.id,
            data : this.form
          }).then(res=>{
            alert(res.response_msg)
            if(res.response_code == 200){
              this.goToTable();
            }
          }).catch(()=>{
            alert('cannot to save online exhibition');
          })
        },
        deleteData(){
          if(this.form.id){
            this.$store.dispatch("OnlineExhibition/deleteOnlineExhibition",this.form.id).then(res=>{
              alert(res.response_msg)
              if(res.response_code == 200){
                this.goToTable();
              }
            }).catch(()=>{
              alert('cannot to delete online exhibition');
            });
          }
        },
        goToTable(){
          this.$router.push("/online-exhibition");
        },
        updateBranch(val){
          this.form.branch_id = val;
        },
        updateTitleTH(val){
          this.form.title_th = val;
        },
        updateTitleEN(val){
          this.form.title_en = val;
        },
        updateDetailTH(val){
          this.form.detail_th = val;
        },
        updateDetailEN(val){
          this.form.detail_en = val;
        },
        updateSlugUrl(val){
          this.form.slug_url = val;
        },
        updateAttachedWebsite(val){
          this.form.attached_website = val;
        },
        updateTemplate(val){
          this.form.template_id = val;
        },
        updatePublishDate(val){
          this.form.publish_date = val
        },
        updateBackgroundColor(val){
          this.form.background_color = val;
          this.modal = false;
        },
        updateCoverImageName(val){
          this.form.cover_image_name = val;
        },
        updateCoverImage(val){
          this.form.cover_image_path = val.fullImagePath;
          this.form.cover_image = val.imagePath;
        },
      }
    }
</script>

<style scoped>

</style>
